import { useFlags } from "src/components/Providers/FeatureFlagProvider";
import useRequiredHasuraRoles from "src/hooks/useRequiredHasuraRoles";
import { HasuraRole } from "src/types/hasuraRole";

/**
 * Custom hook that checks if the current user has school admin permissions
 * to edit form content and verification dialogs.
 *
 * This combines the role check (SCHOOL_ADMIN) with the FF allowlist.
 *
 * @returns boolean indicating if the user has school admin form edit permissions
 */
export const useSchoolAdminFormEditPermissions = (): boolean => {
  const flags = useFlags(["school-admin-form-edit"]);

  return (
    useRequiredHasuraRoles([HasuraRole.SCHOOL_ADMIN]) &&
    flags["school-admin-form-edit"].enabled
  );
};
